<template>
  <div class="row mt-5 align-items-center">
    <div class="col-auto mr-4">
      <h4>Serviços inclusos no plano</h4>
    </div>
    <div class="col-auto text-left">
      <button
        :disabled="pedidoCancelamento || !podeAlterarPlano"
        :title="
          this.resumoContrato.pedido_cancelamento
            ? 'Esse contrato está em processo de cancelamento.'
            : ''
        "
        class="btn btn-customizado btn-customizado-azul"
        @click="trocaDePlano"
      >
        Alterar plano
      </button>
      <button
        v-if="podeAbortarCancelamento && resumoContrato.data_cancelamento !== null || pedidoCancelamento && resumoContrato.data_cancelamento == null"
        title="Abortar o cancelamento"
        style="width: 150px"
        @click="
          abortarCancelamento(
            resumoContrato.id,
            resumoContrato.data_cancelamento !== null && !podeAlterarPlano
          )
        "
        class="btn btn-azul-outline-cancelar mt-2 mb-2 ml-2 mr-2"
      >
        Cancelar operação
      </button>
    </div>
    <div class="col-12 mt-4">
      <table class="table table-custom">
        <thead class="thead" style="background: #9e9e9e12">
          <tr>
            <th class="p-3 border-0" style="width: 80%">Descrição</th>
            <th class="p-3 text-center border-0">Quantidade</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in this.resumoContratoPlano" :key="index">
            <td class="capitalize">{{ item["nome"] }}</td>
            <td class="text-center">{{ item['ilimitado'] === true ? 'ilimitado' : item["quantidade"] }}</td>
          </tr>
          <tr v-if="this.resumoContratoPlano.length === 0">
            <td colspan="100" class="text-center">Sem serviços.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ['trocaDePlano', 'resumoContratoPlano', 'resumoContrato', 'pedidoCancelamento', 'podeAlterarPlano', 'abortarCancelamento', 'podeAbortarCancelamento']
}

</script>
